import React, {useState} from 'react'
import MemberInfoModal from 'components/OurTeam/MemberInfoModal';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import parser from 'html-react-parser'

export default function ExecutiveTeam({data}) {
    const {executiveTeamTitle, executiveTeamBlocks} = data;
    const [selectedTeamMember, setSelectedTeamMember] = useState(null);

    const handleOpen = block => setSelectedTeamMember(block);
    const handleClose = e => {
        if (e.target.classList.contains('modal')) setSelectedTeamMember(null);
    };
    return (
        <>
            <div
                id='executive_team'
                className='executive-wrap light-grey-bg panel-space-70'
            >
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <h2 className='heading-level-2 blue-color text-center'>
                                {executiveTeamTitle && parser(executiveTeamTitle)}
                            </h2>
                        </div>
                    </div>
                    <div className='row team-row h-center'>
                        {executiveTeamBlocks?.map((block, i) => (
                            <div className='col-md-2 col-6 team-col' key={i}>
                                <figure className='team-profile-image'>
                                    <GatsbyImage
                                        image={getImage(block.executiveTeamImage?.localFile)}
                                        alt='image'
                                    />
                                </figure>
                                <button
                                    className='team-name'
                                    type='button'
                                    data-bs-toggle='modal'
                                    data-bs-target='#team_description'
                                    onClick={() => handleOpen(block)}
                                    onKeyDown={() => handleOpen(block)}
                                >
                                    {block.executiveTeamName && parser(block.executiveTeamName)}
                                </button>
                                <div className='team-position-text'>
                                    {block.executiveTeamPosition && parser(block.executiveTeamPosition)}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <MemberInfoModal
                id='team_description'
                onClose={handleClose}
                image={selectedTeamMember?.executiveTeamImage?.localFile}
                name={selectedTeamMember?.executiveTeamName}
                position={selectedTeamMember?.executiveTeamPosition}
                pronouns={selectedTeamMember?.executiveTeamPronounce}
                linkedinLink={selectedTeamMember?.executiveTeamLinkedinLink}
                facebookLink={selectedTeamMember?.executiveTeamFacebookLink}
                email={selectedTeamMember?.executiveTeamEmail}
                description={selectedTeamMember?.executiveTeamDesctiption}
            />
        </>
    )
}
